import _ from 'lodash';
import {apiFetch} from '../utility';
import { UPDATE_LIST } from '../lists';
const apiBase = 'bulkDeliveryBatch';

/*
export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};
*/

export const publicGet = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const submitLoadingNumbers = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.submitLoadingNumbers`,
			params,
			dispatch,
			callback,
		});
	};
};

export const carrierConfirm = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.carrierConfirm`,
			params,
			dispatch,
			callback,
		});
	};
};

export const supplierConfirm = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.supplierConfirm`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'bulkDeliveryBatchIds',
			params,
			dispatch,
			//successMessage : `The ${word} was created successfully.
			//	Click continue to return to the ${word} page.`,
			//onSuccessRedirectTo : `/logistics/${plural}`,
			callback,
		});
	};
};

export const getNextEmail = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.getNextEmail`,
			params,
			dispatch,
			callback,
		});
	};
};

export const activate = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.activate`,
			params,
			dispatch,
			successMessage : `Bulk Deliveries scheduled successfully. ` +
				`Click to continue to return to the bulk deliveries page.`,
			onSuccessRedirectTo : `/logistics/bulkDeliveries`,
			callback : (err, r) => {
				if (!err) {

					const bulkDeliveryBatch = _.get(
						r, ['collections', 'bulkDeliveryBatchCollection', 0]
					);

					if (!bulkDeliveryBatch) {
						return callback('Fatal error. Missing bulkDeliveryBatch.');
					}

					const { bulkDeliveryIds } = bulkDeliveryBatch;
					dispatch({
						type: UPDATE_LIST,
						listName: 'bulkDeliveryIds',
						ids: bulkDeliveryIds,
					});
				}
				return callback(err, r);
			}
		});
	};
};
